<template>
  <Button
    class="searchbox--stats--button"
    size="xs"
    variant="ghost"
    color="primary"
    is-icon
    start-icon="mono-stats"
  >
    <Menu
      class="searchbox--stats--menu"
      anchor="bottom right"
      self="top right"
      :offset="[8, 7]"
      :auto-close="false"
      no-route-dismiss
    >
      <List class="searchbox--stats--menu--list">
        <ListLabel header>
          {{ t('instantsearch:Found.items') }}
        </ListLabel>

        <ListItem
          v-for="(item, i) in items"
          :key="i"
        >
          <ListSection>
            <ListLabel>
              <q-icon
                class="icon"
                :name="item.icon"
              />
              <div class="title">
                {{ item.label }}
              </div>
            </ListLabel>
          </ListSection>

          <ListSection side>
            <Badge color="accent">
              {{ item.count }}
            </Badge>
          </ListSection>
        </ListItem>
      </List>
    </Menu>

    <Tooltip>{{ t('instantsearch:Stats.statsButton.tooltip') }}</Tooltip>
  </Button>
</template>

<script setup>
import { computed } from 'vue'
import { useTranslation } from 'i18next-vue'

defineOptions({ name: 'FacetsStatsMenu' })

const props = defineProps({
  facetsStats: { type: Object, default: null }
})

const { t } = useTranslation()

const items = computed(() => {
  return [
    {
      icon: 'mono-globe',
      label: t('filters:Filter.country.labelPlural'),
      count: props.facetsStats?.['country.name_en']?.total_values
    },
    {
      icon: 'mono-flask',
      label: t('filters:Filter.activeSubstances.labelPlural'),
      count: props.facetsStats?.['active_substances']?.total_values
    },
    {
      icon: 'mono-mah',
      label: t('filters:Filter.mahName.labelPlural'),
      count: props.facetsStats?.['mah_name']?.total_values
    },
    {
      icon: 'mono-ma-status',
      label: t('filters:Filter.maStatus.labelPlural'),
      count: props.facetsStats?.['ma_status']?.total_values
    },
    {
      icon: 'mono-molecule',
      label: t('filters:Filter.atc.labelPlural'),
      count: props.facetsStats?.['atc_paths']?.total_values
    }
    // {
    //   icon: 'mono-market',
    //   label: t('filters:Filter.onMarket.label'),
    //   count: props.facetsStats['on_market']?.total_values
    // },
    // {
    //   icon: 'mono-reimbursement',
    //   label: t('filters:Filter.hasIrp.label'),
    //   count: props.facetsStats['has_irp']?.total_values
    // }
  ]
})
</script>

<style scoped>
@reference "#app-styles.css";

.searchbox--stats--button {
  @apply text-primary-mid;

  &:deep(.q-icon) { @apply text-[14px]! leading-3.5!; }
}
.searchbox--stats--menu--list {
  &:deep(.list-item-standard) {
    .list-section {}
    .list-label {
      @apply flex flex-nowrap items-center gap-sm;

      .icon { @apply text-[14px] leading-3.5; }
    }
  }
}
</style>
